import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    solicitudes: [],
    solicitudesPersonal: null,
    idSolicitud: 0,
  },

  getters: {
    getSolicitudes: (state) => state.solicitudes,

    getIdSolicitud: (state) => state.idSolicitud,

    getSolicitudesPersonal: (state) => state.solicitudesPersonal,
  },

  mutations: {
    SET_SOLICITUDES(state, solicitudes) {
      state.solicitudes = solicitudes;
    },

    SET_SOLICITUDES_PERSONAL(state, solicitudesPersonal) {
      state.solicitudesPersonal = solicitudesPersonal;
    },

    SET_ID_SOLICITUD(state, idSolicitud) {
      state.idSolicitud = idSolicitud;
    },
  },

  actions: {
    async fetchSolicitudes({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/solicitudes')
        .then((response) => {
          commit('SET_SOLICITUDES', response.data.data);
        });
    },

    async saveSolicitud(context, solicitud) {
      await axios
        .post('PoliciaCuadrantes/C3/solicitudes', solicitud)
        .then(() => {
          context.commit('SET_SNACKBAR_MESSAGE', 'Solicitud agregada correctamente', {
            root: true,
          });
        });
    },

    async updateSolicitud(_, solicitud) {
      await axios
        .put(`PoliciaCuadrantes/C3/solicitudes/${solicitud.idSolicitudes}`, solicitud);
    },
  },
};
